// extracted by mini-css-extract-plugin
export default {"formGroup":"DemoForm_formGroup__KfL5g","case":"DemoForm_case__Y+qBM","submitButton":"DemoForm_submitButton__jTsmI"};